var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"booking-status",class:_vm.statusClass()},[_vm._v(_vm._s(_vm.statusName || '-'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }